export default __webpack_public_path__ + "static/media/do2mepro.5f2be3d3.jpg";